import React from 'react';
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  EditButton,
  SimpleForm,
  TextInput,
  SelectInput,
  Filter,
  ShowButton,
  DateField,
  Resource,
  ShowGuesser,
  NumberInput,
  DateInput,
  BooleanField,
  BooleanInput,
  NullableBooleanInput,
  Toolbar,
  SaveButton,
  TopToolbar,
  ExportButton,
  FilterButton,
  CreateButton,
} from 'react-admin';

import UserReferenceField from 'shared-fields/UserReferenceField';
import UserReferenceInput from 'shared-fields/UserReferenceInput';
import AmountField from 'shared-fields/AmountField';
import { generateSelectOptions } from 'utils/filters-utils';
import AccountBalanceWalletRounded from '@mui/icons-material/AccountBalanceWalletRounded';
import ChannelReferenceField from 'shared-fields/ChannelReferenceField';
import { rolesMatch } from 'utils/user';
import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import ChannelReferenceInput from 'shared-fields/ChannelReferenceInput';
import OrganizationReferenceInput from 'shared-fields/OrganizationReferenceInput';
import { ORG_ID } from 'config';
import OrganizationReferenceField from 'shared-fields/OrganizationReferenceField';
import DescriptionField from './DescriptionField';
import { CopyField } from 'shared-fields/CopyField';

function WalletTransactionFilter(props) {
  const hasRole = useHasRole();
  return (
    <Filter {...props}>
      {hasRole(Role.USER_VIEW) && <UserReferenceInput alwaysOn />}
      {hasRole(Role.CHANNEL_VIEW) && <ChannelReferenceInput alwaysOn />}
      {!ORG_ID && <OrganizationReferenceInput alwaysOn />}
    </Filter>
  );
}

export function WalletTransactionListContent() {
  return (
    <Datagrid bulkActionButtons={false}>
      <CopyField source="id" label="ID" />
      <AmountField source="amount" />
      <TextField source="currency" />
      <AmountField source="currencyPriceInTMN" label="Toman Rate" />
      <DescriptionField />
      <UserReferenceField />
      <ChannelReferenceField />
      <BooleanField source="hidden" />
      {!ORG_ID && <OrganizationReferenceField />}
      <DateField source="paidAt" showTime locales="fa-IR" />
      <DateField source="createdAt" showTime locales="fa-IR" />
      <EditButton />
      <ShowButton />
    </Datagrid>
  );
}
export function WalletTransactionList() {
  const hasRole = useHasRole();
  return (
    <List
      sort={{ field: 'id', order: 'DESC' }}
      filters={<WalletTransactionFilter />}
      perPage={25}
      actions={(
        <TopToolbar>
          {hasRole(Role.ORG_SUPER_ADMIN) && <ExportButton />}
          {hasRole(Role.FINANCIAL_MANAGEMENT) && <CreateButton />}
          {/* <FilterButton filters={<WalletTransactionFilter />} /> */}
        </TopToolbar>
      )}
    >
      <WalletTransactionListContent />
    </List>
  );
}

export function WalletTransactionEdit(props) {
  return (
    <Edit {...props}>
      <SimpleForm
        toolbar={(
          <Toolbar>
            <SaveButton />
          </Toolbar>
        )}
      >
        <TextInput source="id" disabled />
        <NumberInput source="amount" disabled />
        <NumberInput source="currencyPriceInTMN" label="Toman Rate" />
        <TextInput source="description" multiline />
        <UserReferenceInput disabled />
        {!ORG_ID && <OrganizationReferenceInput />}
        <DateInput source="paidAt" locales="fa-IR" defaultValue={new Date()} />
        <NullableBooleanInput source="hidden" />
      </SimpleForm>
    </Edit>
  );
}

export function WalletTransactionCreate(props) {
  return (
    <Create {...props}>
      <SimpleForm>
        <NumberInput source="amount" defaultValue={0} />
        <TextInput source="description" multiline />
        {!ORG_ID && <OrganizationReferenceInput />}
        <UserReferenceInput sameOrg />
        <SelectInput
          source="currency"
          choices={[
            { id: 'USD', name: 'USD' }, { id: 'TMN', name: 'TMN' }, { id: 'GBP', name: 'GBP' },
          ]}
          defaultValue="GBP"
        />
        <NumberInput source="currencyPriceInTMN" label="Toman Rate" />
        <DateInput source="paidAt" locales="fa-IR" defaultValue={new Date()} />
        <NullableBooleanInput source="hidden" />
      </SimpleForm>
    </Create>
  );
}

export const renderTransactionResource = (roles) => (
  <Resource
    options={{
      label: 'Transactions',
    }}
    name="transactions"
    icon={AccountBalanceWalletRounded}
    show={ShowGuesser}
    list={WalletTransactionList}
    edit={rolesMatch({ roles, role: Role.WALLET_TRANSACTION_EDIT }) && WalletTransactionEdit}
    create={rolesMatch({ roles, role: Role.WALLET_TRANSACTION_CREATE }) && WalletTransactionCreate}
  />
);
